import { render, staticRenderFns } from "./BioTemplate.vue?vue&type=template&id=5cfb1aa6&scoped=true&"
import script from "./BioTemplate.vue?vue&type=script&lang=js&"
export * from "./BioTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BioTemplate.vue?vue&type=style&index=0&id=5cfb1aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfb1aa6",
  null
  
)

export default component.exports